export default __webpack_public_path__ + "static/media/cx.dda4107f.svg";